module.exports = __webpack_public_path__ + "img/beauty.45280b25.svg";